import initialState from '../initialstate';
import * as types from '../../actions/actiontypes';
/**
 * This reducer function handles all the actions related to the top-level objects.
 * @param {Object} state - A portion of the overall Redux state, specifically the
 *      store.<%=names.camel%> object, representing the current data.
 * @param {Object} action - Action object containing type and other values
 * @return {*} current state or array of language objects
 */
export default function GetOtherEngagementsReviewNotesCountReducer(
	state = initialState.otherEngagementsReviewNotes,
	action
) {
	switch (action.type) {
		case types.GET_OTHERENGAGEMENTS_REVIEWNOTES: {
			let otherEngagementsReviewNotes = action.response;
			return otherEngagementsReviewNotes;
		}
		case types.CLEAR_OTHER_ENGAGEMENTS_REVIEWNOTES: {
			return {};
		}
		default:
			return state;
	}
}
